import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {delay, finalize} from 'rxjs/operators';
import {NgxUiLoaderService} from 'ngx-ui-loader';

@Injectable()
export class HttpInterceptorMultiverse implements  HttpInterceptor{

    private readonly headers = new HttpHeaders({'Content-language':'en'});
    constructor(private ngxLoader: NgxUiLoaderService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.ngxLoader.start();
        const request = req.clone({
           setHeaders:{'utcoffset': '330', 'Content-language':'en'}
        });

        return next.handle(request).pipe(
            finalize(() => this.ngxLoader.stop()),

        );;
    }



}
